export default {"src":"/_next/static/media/tag.fbe734eb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};